// extracted by mini-css-extract-plugin
export default {"container":"MainDiv_container__RNpBZ","containerList":"MainDiv_containerList__lH32g","elementComponent":"MainDiv_elementComponent__GntMy","title":"MainDiv_title__njTWI"};